import * as React from 'react';
import styled from 'styled-components';
import { BREAKPOINT, COLOR, DISPLAY } from '@latitude/core/utils/constants';
var Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "FramedContainer__Container",
  componentId: "sc-17ma0hs-0"
})(["border:solid 1px ", ";", ";background-color:", ";text-align:center;position:relative;display:block;width:100%;max-width:920px;margin:0 auto 20px;z-index:1;@media (min-width:", "){margin:0 auto 60px;}&:after{display:block;width:100%;height:100%;content:' ';position:absolute;top:10px;right:-10px;border:solid 40px ", ";z-index:-1;@media (min-width:", "){top:60px;right:-60px;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme && theme.contentBorderColor ? theme.contentBorderColor : defaultTheme.contentBorderColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme && theme.contentBorderColor === DISPLAY.NONE && 'border: none';
}, COLOR.WHITE, BREAKPOINT.LG, function (_ref3) {
  var theme = _ref3.theme;
  return theme && theme.frameColor ? theme.frameColor : defaultTheme.frameColor;
}, BREAKPOINT.LG);
var Content = /*#__PURE__*/styled.div.withConfig({
  displayName: "FramedContainer__Content",
  componentId: "sc-17ma0hs-1"
})(["background-color:", ";width:100%;", " display:block;position:relative;z-index:2;"], COLOR.WHITE, function (_ref4) {
  var minHeight = _ref4.minHeight;
  return minHeight && "min-height: " + minHeight + ";";
});
var defaultTheme = {
  frameColor: COLOR.GREY12,
  contentBorderColor: COLOR.GREY10
};

var FramedContainer = function FramedContainer(_ref5) {
  var children = _ref5.children,
      minHeight = _ref5.minHeight,
      theme = _ref5.theme;
  return /*#__PURE__*/React.createElement(Container, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Content, {
    minHeight: minHeight
  }, children));
};

export default FramedContainer;